import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import classNames from 'classnames';
import { isEmpty } from 'ramda';

import Title from '../../../Title';
import Tooltip from '../../../../common/PortalledTooltip';
import Address from '../../../../common/Address';
import { poLocationList } from '../shapes';

const LocationList = ({
  canEditProducts,
  listItems,
  addressesById,
  shopNamesById,
  goToEditing,
}) => (
  <div className="c-wrapper">
    <Title namespace="po">Locations</Title>
    <ReactTable
      data={listItems}
      showPagination={false}
      defaultPageSize={10000}
      minRows={0}
      className={
        classNames('c-table-new',
          { 'c-no-hover': !canEditProducts }
        )
      }
      getTrProps={(_, row) => ({
        onClick: () => canEditProducts && goToEditing(row.original.ownerId),
      })}
      columns={[
        {
          Header: 'Location',
          accessor: 'ownerId',
          Cell: row => shopNamesById[row.value],
          width: 400,
        },
        {
          Header: (
            <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-center">
              <span>PO Prefix</span>
              <Tooltip className="u-type--no-transform">
                PO Prefixes will precede any future PO numbers from this location.
              </Tooltip>
            </div>
          ),
          accessor: 'prefix',
          Cell: row => (row.value === null || isEmpty(row.value) ? 'N/A' : row.value),
          width: 180,
        },
        {
          Header: (
            <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-center">
              <span>PO Starting Number</span>
              <Tooltip className="u-type--no-transform">
                Assigning a PO starting number to a location will start to generate that location's
                PO numbers from that starting number, skipping any previous numbers.
              </Tooltip>
            </div>
          ),
          accessor: 'startingPONumber',
          Cell: row => (row.value || 'N/A'),
          width: 180,
        },
        {
          Header: (
            <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-center">
              <span>Bill To Address</span>
              <Tooltip className="u-type--no-transform">
                The Bill To address appears on POs generated for this location.
                The addresses are pulled from your brand’s Business Location
                or your Location’s Business Location in Commander Settings.
              </Tooltip>
            </div>
          ),
          accessor: 'billingAddressId',
          Cell: row => <Address address={addressesById[row.value]} />,
        },
      ]}
    />
  </div>
);

LocationList.propTypes = {
  canEditProducts: PropTypes.bool.isRequired,
  listItems: poLocationList.isRequired,
  goToEditing: PropTypes.func.isRequired,
  addressesById: PropTypes.object.isRequired,
  shopNamesById: PropTypes.object.isRequired,
};

export default LocationList;
